import { defineStore } from 'pinia';

const message = {
    text: null,
    level: 'error'
}

export const useMessageStore = defineStore('message', {
    state: () => {
        return {
            message: {...message},
            errors: [],
            autoDismissTimeout: null
        }
    },
    getters: {
        show() {
            return this.message?.text !== null && (this.message?.text ?? []).length > 0;
        }
    },
    actions: {
        setAlert(value) {
            // Clear any existing timeout
            if (this.autoDismissTimeout) {
                clearTimeout(this.autoDismissTimeout);
                this.autoDismissTimeout = null;
            }

            this.message = {
                text: value.text ?? message.text,
                level: value.level ?? message.level
            }

            // Auto-dismiss after 5 seconds
            this.autoDismissTimeout = setTimeout(() => {
                this.clear();
            }, 3000);
        },
        setErrors(errors) {
            this.errors = errors ?? [];
        },
        clear() {
            if (this.autoDismissTimeout) {
                clearTimeout(this.autoDismissTimeout);
                this.autoDismissTimeout = null;
            }
            this.message = {...message}
        }
    }
})